import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Search } from '../../../components/Icon';
import { changeCompanyFilter, updateCompanySearchString } from '../actions';
import { getStringWithoutSymbols } from '../helpers';
import styles from './SearchText.module.css';

const Container = styled.div``;

const STATE = {
  search: '',
};
/* eslint-disable react/prefer-stateless-function */
class CompaniesearchTextComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
      search: props.filter.zoeken || '',
    });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  doSearch() {
    this.props.setSearchString(getStringWithoutSymbols(this.state.search));
  }

  handleKeyPress = event => {
    if (event.key === 'Enter') {
      this.props.setSearchString(getStringWithoutSymbols(this.state.search));
    }
  };

  searchStringChangeHandler() {
    this._t = this.timeout(
      () => {
        this.props.setSearchString(this.state.search);
      },
      600,
      this._t,
    );
  }

  render() {
    return (
      <div className="d-flex">
        <input
          type="text"
          className={`form-control fw-light ${styles.Input}`}
          name="search"
          value={this.state.search}
          placeholder={`${this.lblStr('zoeken')}...`}
          onChange={evt => {
            this.props.overviewPage && this.props.updateSearchString(evt.target.value);
            this.setState({ search: evt.target.value });
          }}
          onKeyPress={this.handleKeyPress}
        />
        <button className={`btn btn-outline-secondary ${styles.Button}`} type="button" onClick={this.doSearch.bind(this)}>
          <Search />
        </button>
      </div>
    );
  }
}

CompaniesearchTextComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    //filter: selectVehicleFilter(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setSearchString(string) {
      dispatch(changeCompanyFilter('searchString', string));
    },
    updateSearchString(string) {
      dispatch(updateCompanySearchString(string));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompaniesearchText = compose(withConnect, withRouter, injectIntl)(CompaniesearchTextComp);
